module.exports = __webpack_public_path__ + "media/images/flags/32/Rwanda-3ee58f4f35217efeab8770db3af87a34.png";